import { api } from 'boot/axios.js'

export async function setItem(ctx, data = {}) {
  ctx.commit('item', data)
}


